import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import FailureReasonDesc from './failureReasonDesc.mdx';
import AdditionalInfo from './checkoutDataAdditionalInfo.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='Properties' mdxType="Group">
        <Item title='payment' subtitle='IPrimerCheckoutDataPayment' mdxType="Item">
                <Group summary='Properties' mdxType="Group">
                        <Item title='id' subtitle='string' mdxType="Item">
                                Primer's unique identifier for the payment.
                        </Item>
                        <Item title='orderId' subtitle='string' mdxType="Item">
                                Your order identifier as provided in the client session.
                        </Item>
                        <Item title='paymentFailureReason' subtitle='PrimerPaymentErrorCode' mdxType="Item">
                               <FailureReasonDesc mdxType="FailureReasonDesc" /> 
                        </Item>
                </Group>
        </Item>
        <Item title='additionalInfo' subtitle='object' mdxType="Item">
          Custom information, that depends on the payment method.
          <AdditionalInfo mdxType="AdditionalInfo" />
        </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      